import { Controller } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const BaseCheckboxTheme = (props) => {
    const {
        id,
        name,
        label,
        errors,
        className,
        inputClassName,
        innerWrapperClassName,
        disabled = false,
        control,
        labelClassName
    } = props;

    const errorClassname = errors?.length ? 'border-theme1-error' : '';

    return (
        <div className={twMerge('w-full', className)}>
            <Controller
                render={({ field }) => (
                    <div className={twMerge('flex items-center gap-2', innerWrapperClassName)}>
                        <input
                            type='checkbox'
                            checked={field.value || false}
                            onChange={(e) => field.onChange(e.target.checked)}
                            {...field}
                            disabled={disabled}
                            className={twMerge(
                                'h-7 w-7 appearance-none cursor-pointer rounded border border-theme1-primary',
                                'checked:bg-theme1-tan relative',
                                'before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
                                'before:content-[""] before:w-4 before:h-4 before:bg-no-repeat before:bg-center before:opacity-0',
                                "checked:before:opacity-100 checked:before:bg-[url('/src/resources/images/checkmark.svg')]",
                                errorClassname,
                                inputClassName
                            )}
                        />

                        {label && (
                            <label htmlFor={id ?? name} className={twMerge('text-theme1-primary2', labelClassName)}>
                                {label}
                            </label>
                        )}
                    </div>
                )}
                control={control}
                name={name}
            />

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseCheckboxTheme;
